export default "__VITE_ASSET__40ebc59a__"